import styled from '@emotion/styled';

// If needed variations such as size should be added here
export const StyledLogo = styled.svg(({ theme }) => ({
    height: theme.space[8],
    width: theme.space[8],
}));
